<template>
    <v-select
        :aria-label="formattedAriaLabel(question[`question${upperLocale}`] + $t(`appt.accessibility.dropdown`) + currentResponse, question.required)"
        :items="items"
        item-value="id"
        :item-text="item => $t(`base.${item.key}`)"
        :label="formattedLabel(question[`label${upperLocale}`], question.required)"
        :rules="(question.required ? [requiredField()] : [])"
        tabindex="-1"
        ref="dynamicDropdown"
        :id="'question'+question.id"
        @input="update($event)"
    />
</template>

<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { inputHelpers } from '@/mixins/inputHelpers';
export default {
    name: 'dynamic-drop-down-field',
    props: {
        question: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            upperLocale: 'upperLocale',
        }),
        currentResponse() {
            const responseKey = this.items.filter(item => item.id === this.question.response)[0]?.key ?? null;
            if (responseKey === null) {
                return '';
            }
            return ' Option : ' + this.$t(`base.${responseKey}`) + ' ' + this.$t(`base.selected`);
        },
    },
    mounted() {
        this.addFocus();
    },
    data: () => ({
        dynamicDropdownResponse: '',
        items: [{ id: '1', key: 'yes' }, { id: '0', key: 'no' }],
    }),
    mixins: [formRules, inputHelpers],
    methods: {
        update(event) {
            this.$emit('updateQuestionResponse', { 'questionId': this.question.id, 'dynamicResponse': event, 'customId': 'question' + this.question.id });
        },
        addFocus() {
            const button = this.$refs.dynamicDropdown?.$el.querySelector('.v-input__slot');

            if (!button) return;

            button.setAttribute('tabindex', '0');
            button.focus();

            if (button._hasKeyListener) return;

            button.addEventListener('keydown', (e) => {
                if (e.key !== 'Enter') return;

                e.preventDefault();
                button.click();

                setTimeout(() => {
                    // eslint-disable-next-line no-unused-expressions
                    document.querySelector('.v-menu__content.menuable__content__active .v-list-item')?.focus();
                }, 100);
            });

            button._hasKeyListener = true;
        },
    },
};
</script>
